function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.29 8.451a1 1 0 00-.61 1.906 2.709 2.709 0 011.864 2.36 1 1 0 101.993-.167 4.709 4.709 0 00-3.247-4.1z",
  fill: "#313D53"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.964 6.753c2.671-3.936 8.133-4.825 12.031-2.382 3.9-2.441 9.358-1.552 12.034 2.38 1.733 2.55 2.078 5.937 1.094 8.997l-.004.01-.003.011c-2.099 6.052-7.684 10.015-12.581 13.061a1 1 0 01-1.042.009c-4.95-2.965-10.524-7.062-12.607-13.07l-.004-.01-.003-.011c-.984-3.058-.645-6.446 1.085-8.995zm1.655 1.123c2.13-3.14 6.715-3.79 9.776-1.493a1 1 0 001.2 0c3.063-2.295 7.644-1.646 9.78 1.494 1.341 1.97 1.664 4.699.847 7.247-1.78 5.121-6.478 8.69-11.224 11.683-4.747-2.901-9.451-6.599-11.219-11.682-.817-2.55-.498-5.279.84-7.25z",
  fill: "#313D53"
})));